<template>
	<div>
		<div class="imagecontainer" >
			<img src="../assets/HelloNovel.png" style="width: 770px;height: 90px;"/>
		</div>
		<div class="imagecontainerone" style="padding-top: 40px;">
			<img src="../assets/fall.png" style=" width: 620px;height: 36px;"/>
		</div>
		
		<div class="imagecontainerone" style="padding-top: 50px;">
			<div class="line">
				<img src="../assets/novelphone.png" class="lineimg"/>
			</div>
			<div class="line">
				<img src="../assets/novelphoneone.png" class="lineimg"/>
			</div>
			<div class="line">
				<img src="../assets/novelphonetwo.png" class="lineimg"/>
			</div>
		</div>
		
		<div class="imagecontainerone" style="padding-top: 50px;">
			<div class="extensivebg">
				<div class="extensive">EXTENSIVE CONTENT</div>
			</div>
		</div>
		
		<div class="imagecontainerone" style="padding-top: 50px;">
			<div class="designedbg">
				<div class="designed">
					HelloNovel is designed with female readers in mind, featuring a captivating selection of romantic love stories. Every story delivers an unforgettable experience,with enchanting plotsand engaging characters that draw you in from beginning to end.
				</div>
			</div>
		</div>
		
		<div class="imagecontainerone" style="padding-top: 60px;">
			<div class="novelone">
				<img src="../assets/novelone.png" class="novelimg"/>
			</div>
			<div class="novelone">
				<img src="../assets/noveltwo.png" class="novelimg"/>
			</div>
			<div class="novelone">
				<img src="../assets/novelthree.png" class="novelimg"/>
			</div>
			<div class="novelone">
				<img src="../assets/novelfour.png" class="novelimg"/>
			</div>
			<div class="novelone">
				<img src="../assets/novelfive.png" class="novelimg"/>	
			</div>
		</div>
		
		<nav class="navbar" style="padding-bottom: 60px;">
		      <ul class="nav-list" >
		        <li class="nav-item" v-for="(item,index) in tabsList" :key="index">
					<img src="../assets/Group.png" style="width: 166px;height: 48px;"/>
					<div class="about">{{item.name}}</div>
					<div v-show="index==0" class="content" @click="Jump('HelloNovel')">HelloNovel</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content" @click="Jump('Company')">Company</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content">Privacy policy</div>
					<div v-show="index==0" style="margin-top: 10px;" class="content">Terms of service</div>
					<div v-show="index==1" class="content" @click="Jump('Author Recruitment')">Author Recruitment</div>
					<div v-show="index==2" class="content" @click="Jump('Contact Information')">Contact Information</div>
				</li>
				
		      </ul>
		</nav>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				tabsList:[{name:'About us'},{name:'Join us'},{name:'Contact us'},{name:'Stay tuned...'}]
			}
		},
		
		methods:{
			Jump(val){
				this.$emit('message-from-child', val);
			}
		}
	}
</script>

<style scoped="scoped">
	.imagecontainer {
	  display: flex;
	  justify-content: center;
	  padding-top: 20px;
	  
	}
	
	.imagecontainerone {
	  display: flex;
	  justify-content: center;
	  padding-top: 20px;
	}
	
	.navbar {
	  overflow: hidden;
	  padding-top: 58px;
	  /* position: absolute;
	  bottom: 0;
	  left: 0;
	  right: 0;
	  margin: auto;
	  width: 100%; */
	  /* padding-bottom: 150px; */
	}
	
	.nav-list {
	  list-style-type: none; 
	  margin: 0;
	  padding: 0;
	  display: flex;
	  justify-content: center;
	}
	
	.nav-item {
	  float: left; 
	  padding: 20px 30px;
	  background-color: white;
	}
	
	
	.line{
		padding-right: 50px;
		padding-bottom: 50px;
	}
	
	.lineimg{
		width: 222px;
		height: 440px;
		
		transition: transform 0.3s ease; /* 平滑过渡 */
		cursor: pointer;
	}
	
	.lineimg:hover{
		transform: scale(1.2); /* 鼠标悬停时放大 1.2 倍 */
	}
	
	.extensivebg{
		width: 572px;
		height: 25px;
		background: #B4CCED;
		opacity: 0.7;
	}
	
	.extensive{
		font-family: Inter, Inter;
		font-weight: 900;
		font-size: 36px;
		color: #FF8215;
		text-align: center;
		margin-top: -26px;
	}
	
	.designedbg{
		width: 1135px;
		height: 121px;
		background: #FFFFFF;
		border-radius: 20px;
		opacity: 0.9;
	}
	
	.designed{
		font-family: Inter, Inter;
		font-weight: 500;
		font-size: 18px;
		color: #1A1A1A;
		text-align: center;
		padding-left: 75px;
		padding-top: 29px;
		width: 987px;
	}
	
	.novelone{
		padding-right: 30px;
		padding-bottom: 50px;
	}
	
	.novelimg{
		width: 195px;
		height: 285px;
	}
	
	.about{
		margin-top: -38px;
		font-family: Inter, Inter;
		font-weight: bold;
		font-size: 19px;
		color: #FFFFFF;
	}
	
	.content{
		margin-top: 20px;
		font-family: Inter, Inter;
		font-weight: normal;
		font-size: 13px;
		color: #606060;
	}
</style>